<template>
  <div class="page" :class="bodyHide==1?'border-box overflow':''" v-wechat-title="$route.meta.title">

    <div class="main-scroll-view" style="position: relative; width: 100%; height: auto;">
      <!--顶图-->
      <div class="banner border-box">
        <Swiper v-if="banners!=null && banners.length >= 1" :banners="banners" :type="'detail'"></Swiper>
      </div>
      <div class="article-info clearfix">
        <div class="article-right">
          <p class="name hide">{{res.name}}</p>
          <p class="date">{{res.rootTime}}</p>
        </div>
        <div class="article-like" :class="res.iszan==1?'curr':''" @click="articleZan">
          <img v-if="res.iszan==0" src="../../assets/city_icon11.png" alt="">
          <img v-if="res.iszan==1" src="../../assets/city_icon11_curr.png" alt="">
          {{res.zan}}
        </div>
      </div>
      <div class="article">
        <div v-html="res.content"></div>
      </div>
    </div>


    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>
</template>
<script>
  import { mapState, mapMutations } from 'vuex'
  import Swiper from '../../components/Swiper'
  import P400 from '../../components/P400'
  import {uploadUserBrowse,citySiteRootDetail,citySiteFoodZan} from "@/service/getData";
  import {wxGetPosition,wxImgPreview, wxShareme,artRecord} from '@/utils/wechat'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)
  var fromPath,fullPath;
  export default {
    data(){
      return{
        id: '', //文章id
        userInfo: {}, //用户信息
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey:'',
        appKeyA: '',
        res:{
          noReward: 1
        },//接口所有数据
        banners:'',//轮播图数组
        bodyHide:0,//页面是否滚动
        P400: 0, //系统维护中
      }
    },
    computed: {},
    created() {
      this.id = this.$route.query.id;
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }
      this.$loading.show('数据加载中');
      this.initData();
    },
    beforeDestroy(){},

    mounted(){},
    methods: {
      async initData(){
        var self = this;
        this.userInfo = getStore("userInfo");
        let res = await citySiteRootDetail({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          id: this.id
        });
        if (res.errcode == "00000"){
          this.$loading.hide();
          this.res = res.data;
          this.banners = this.res.logo.split(',')
          this.$route.meta.title = this.res.name;
          var share = res.data.share;
          let link = 'city-strategy-detail?id=' + this.id + '&TimeStamp=' + this.TimeStamp + '&appKey=' + this.appKey;
          if(share == null){
            let title = '攻略详情';
            let desc = '讲人文 . 听趣史 . 说美食 . 游景区';
            let img = '';
            var bid = this.id;
            wxShareme(title,desc,img,link,function(){
              artRecord(bid);
            });
          }else {
            wxShareme(share.title,share.desc,share.logo,link,function(){
              artRecord(bid);
            });
          }

        }else {
          this.$loading.hide();
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      //文章点赞
      async articleZan(){
        let res = await citySiteFoodZan({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          rid: this.id
        });
        if(res.errcode == "00000"){
          this.res.zan++;
          this.res.iszan = 1;
          this.$toast("点赞成功",{ location: ''})
        }else{
          this.$toast(res.errmsg,{ location: ''})
        }
      },





    },
    watch:  { },
    components: {
        Swiper,
        wxConfirm,
        P400
    },

  }

</script>

<style scoped>
  .page{padding-bottom:0; background-color: #fff; }
  * { touch-action: pan-y; }
  .banner{position:relative;height:3rem;border-radius:.07rem}
  .article-info{position:relative;padding: 0 .28rem;margin-top: .15rem;}
  .article-right{position:relative;width:80%;height: .9rem;}
  .article-right .name{font-weight:bold;font-size: .36rem;color: #333;}
  .article-right .date{margin-top: .12rem;font-size: .26rem;color: #666;}
  .article-like{position: absolute;right: .28rem;top:50%;height: .5rem;padding: 0 .16rem;font: .24rem/.5rem "Microsoft YaHei";color:#f23e6c;background:none;border:1px solid #f23e6c;border-radius:.3rem;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .article-like.curr{color: #fff;background: #f23e6c;}
  .article-like img{float: left;width: auto;height: .24rem;margin-top: .13rem;margin-right: .14rem;}
  .article{padding: 0 .28rem .4rem;margin-top: .64rem;font: .24rem/.36rem "Microsoft YaHei";color: #777;}
</style>



// WEBPACK FOOTER //
// src/page/city-site/city-strategy-detail.vue